import { getInitialMapStyle } from '@/features/map/basemapCatalog';

/**
 * Warm the HTTP cache for the default basemap when the SPA boots straight
 * onto the Live Map (a reload, a bookmark, the tab Ms. Mayan filmed).
 *
 * MapLibre only learns the style URL after the session resolves and the
 * map mounts (~1 s in), then walks a serial chain: style JSON -> tile index
 * (TileJSON) -> sprite + tiles -> glyphs. Fetching the first three here at
 * t=0 lets MapLibre's own requests hit the cache (OpenFreeMap serves them
 * with public max-age) so the chain starts a second earlier on a cold load.
 * Failures are ignored; MapLibre fetches normally either way.
 */
export function prefetchDefaultBasemap({ pathname = window.location.pathname } = {}) {
  if (pathname !== '/map') return;
  let style;
  try {
    style = getInitialMapStyle({});
  } catch {
    return;
  }
  if (typeof style !== 'string' || !/^https:\/\//.test(style)) return;
  const get = (url) => fetch(url, { mode: 'cors' }).catch(() => null);
  get(style)
    .then((res) => (res && res.ok ? res.json() : null))
    .then((json) => {
      if (!json) return;
      for (const src of Object.values(json.sources || {})) {
        if (src && typeof src.url === 'string') get(src.url);
      }
      if (typeof json.sprite === 'string') {
        const ratio = window.devicePixelRatio > 1 ? '@2x' : '';
        get(`${json.sprite}${ratio}.json`);
        get(`${json.sprite}${ratio}.png`);
      }
    })
    .catch(() => {});
}
